import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Park } from '../models/park';
import { AuthService } from '../auth-n-routing/auth-service.service';
import {BusyServices} from '../commons/busy.service';
import {ParkType} from '../models/parkType';
import {UserAdministratePark} from '../models/userAdministrateParks';
import {Subject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UsersAdministrateParksHandlerService {

  private addUserAdministrateParksURI= 'users/administratepark';
  private getUserAdministrateParksByIDURI= 'users/getadministratepark';
  private deleteUserAdmistrateParkByUadIDURI= 'users/deleteadministratepark';
  private restoreUserAdmistrateParkByUadIDURI= 'users/restoreadministratepark';


  /* Variabili per passaggi di elementi e dati tra i componenti parent (super-admin) e vari children gestiti in route */
  private newParkSource = new Subject<string>();
  newParkCreated$ = this.newParkSource.asObservable();


  constructor(private busy: BusyServices, private http: HttpClient, private authService: AuthService) { }

  addUserAdministrateParks(user_id: number, park_id: number): Promise<UserAdministratePark> {
    return new Promise<UserAdministratePark>((resolve, reject) => {

      const _http = this.http.post(environment.api.baseUrl + this.addUserAdministrateParksURI,
        {user_id, park_id},
        environment.api.config).subscribe(
        (data: any) => {
          console.log(data);
          if (data['userAdministrateParks']) {
            resolve(new UserAdministratePark(data['userAdministrateParks']));
          } else {
            resolve(new UserAdministratePark(undefined));
          }
        },
        err => {
          reject();
        });
      this.busy.setBusy(_http);
    });
  }

  getUserAdmistrateParkByParkID( park_id: number): Promise<UserAdministratePark[]> {
    return new Promise<UserAdministratePark[]>((resolve, reject) => {

      const _http = this.http.get(environment.api.baseUrl + this.getUserAdministrateParksByIDURI + '/' + park_id,
        environment.api.config).subscribe(
        (data: any) => {
          console.log(data);
          const toRet = [];
          if (data.data) {
            data.data.forEach((uad_server_obj) => {
              const uad_raw = uad_server_obj['userAdministrateParks'];
              toRet.push(new UserAdministratePark(uad_raw));
            });
            resolve(toRet);
          } else {
            resolve(toRet);
          }
        },
        err => {
          reject();
        });
      this.busy.setBusy(_http);
    });
  }


  deleteUserAdmistrateParkByUadID( uad_id: number): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const _http = this.http.post(environment.api.baseUrl + this.deleteUserAdmistrateParkByUadIDURI,
        {uad_id},
        environment.api.config).subscribe(
        (data: any) => {
         resolve(true);
        },
        err => {
          reject();
        });
      this.busy.setBusy(_http);
    });
  }

  restoreUserAdmistrateParkByUadID( uad_id: number): Promise<boolean> {
      return new Promise<boolean>((resolve, reject) => {
        const _http = this.http.post(environment.api.baseUrl + this.restoreUserAdmistrateParkByUadIDURI,
          {uad_id},
          environment.api.config).subscribe(
          (data: any) => {
           resolve(true);
          },
          err => {
            reject();
          });
        this.busy.setBusy(_http);
      });
    }


   /* METODI per passaggi di elementi e dati tra i componenti parent (super-admin) e vari children gestiti in route */
  newPark() {
    this.newParkSource.next(undefined);
  }




}
